import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const SuccessIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
                 isFilled={true}
        >{'\ue86c'}</MuiIcon>
    );
}